/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'xrx-circular-progess-bar',
  templateUrl: './xrx-circular-progess-bar.component.html',
  styleUrls: ['./xrx-circular-progess-bar.component.less'],
  standalone: false,
})
export class XrxCircularProgressComponent implements OnInit {
  circle: SVGCircleElement | null = null;
  radius = 0; // = this.circle.r.baseVal.value;
  circumference = 0; // = this.radius * 2 * Math.PI;
  animationId = 0;
  percentage = 0;
  roundPercentage = 0;
  complete = false;
  checkmark: HTMLElement | null = null;

  ngOnInit() {
    this.circle = document.querySelector('.progress-ring__circle');
    this.checkmark = document.querySelector('.checkmark');
    if (this.checkmark) {
      this.checkmark.style.opacity = '0';
      this.checkmark.style.top = '0';
    }
    if (this.circle) {
      this.radius = this.circle.r.baseVal.value;
      this.circumference = this.radius * 2 * Math.PI;
      this.circle.style.strokeDasharray = `${this.circumference} ${this.circumference}`;
      this.circle.style.strokeDashoffset = this.circumference.toString();
    }
  }

  /**
   * Use requestAnimationFrame instead of transition for compatibility with IE
   * @param percent
   */
  public setProgress(percent: number) {
    this.percentage += percent;
    this.roundPercentage = Math.round(this.percentage);
    if (this.roundPercentage > 100) {
      this.roundPercentage = 100;
    }
    const offset = (percent / 100) * this.circumference;

    if (this.circle) {
      cancelAnimationFrame(this.animationId);
      this.animationId = requestAnimationFrame(() =>
        this.step(this.circle!, Math.floor(offset)),
      );
    }

    if (this.percentage >= 100) {
      this.percentage = 100;
      setTimeout(async () => {
        this.complete = true;
        if (this.checkmark) {
          this.checkmark.style.top = '-10px';
          this.checkmark.style.opacity = '1';
          this.checkmark.classList.add('check');
        }
      }, 1000);
    }
  }

  private step(circle: SVGCircleElement, distance: number) {
    const updateOffset = parseFloat(circle.style.strokeDashoffset) - 1;
    if (updateOffset >= 0) {
      circle.style.strokeDashoffset = updateOffset.toString();
    }

    if (distance > 0 && updateOffset > 0) {
      requestAnimationFrame(() => this.step(circle, Math.floor(--distance)));
    }
  }
}
